var _defs, _mask, _g, _defs2, _mask2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundRightMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "720px",
    height: "1984.421px",
    viewBox: "0 -520.784 720 1984.421",
    enableBackground: "new 0 -520.784 720 1984.421",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 7.119,
    y: -496.327,
    width: 725.599,
    height: 1015.105
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 7.119,
    y: -496.327,
    width: 725.599,
    height: 1015.105,
    id: "mask0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15.881,
    y: -517.401,
    fill: "#C4C4C4",
    filter: "url(#Adobe_OpacityMaskFilter)",
    width: 720,
    height: 1024
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M269.105-478.238c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.049-9.045,9.045C260.06-482.287,264.11-478.238,269.105-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.888-478.238c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.994,0-9.044,4.049-9.044,9.045C305.844-482.287,309.894-478.238,314.888-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M360.672-478.238c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C351.627-482.287,355.677-478.238,360.672-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M406.455-478.238c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C397.411-482.287,401.46-478.238,406.455-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.239-478.238c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C443.194-482.287,447.244-478.238,452.239-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M498.022-478.238c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.045,4.049-9.045,9.045C488.978-482.287,493.027-478.238,498.022-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.807-478.238c4.994,0,9.044-4.049,9.044-9.044c0-4.996-4.05-9.045-9.044-9.045 c-4.996,0-9.046,4.049-9.046,9.045C534.761-482.287,538.811-478.238,543.807-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.589-478.238c4.996,0,9.045-4.049,9.045-9.044c0-4.996-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.049-9.044,9.045C580.545-482.287,584.594-478.238,589.589-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.373-478.238c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C626.328-482.287,630.377-478.238,635.373-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M681.156-478.238c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C672.112-482.287,676.161-478.238,681.156-478.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.239-431.88c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S447.244-431.88,452.239-431.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M498.022-431.88c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.044-9.045-9.044 s-9.045,4.049-9.045,9.044S493.027-431.88,498.022-431.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.807-431.88c4.994,0,9.044-4.049,9.044-9.044s-4.05-9.044-9.044-9.044 c-4.996,0-9.046,4.049-9.046,9.044S538.811-431.88,543.807-431.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.589-431.88c4.996,0,9.045-4.049,9.045-9.044s-4.049-9.044-9.045-9.044 c-4.995,0-9.044,4.049-9.044,9.044S584.594-431.88,589.589-431.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.373-431.88c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S630.377-431.88,635.373-431.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M681.156-431.88c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044S676.161-431.88,681.156-431.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.239-385.521c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S447.244-385.521,452.239-385.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M498.022-385.521c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.045-9.045-9.045 s-9.045,4.05-9.045,9.045S493.027-385.521,498.022-385.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.807-385.521c4.994,0,9.044-4.05,9.044-9.045s-4.05-9.045-9.044-9.045 c-4.996,0-9.046,4.05-9.046,9.045S538.811-385.521,543.807-385.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.589-385.521c4.996,0,9.045-4.05,9.045-9.045s-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.05-9.044,9.045S584.594-385.521,589.589-385.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M635.373-385.521c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S630.377-385.521,635.373-385.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M681.156-385.521c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S676.161-385.521,681.156-385.521z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.239-339.164c4.995,0,9.044-4.05,9.044-9.045c0-4.995-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044C443.194-343.213,447.244-339.164,452.239-339.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M498.022-339.164c4.995,0,9.045-4.05,9.045-9.045c0-4.995-4.05-9.044-9.045-9.044 s-9.045,4.049-9.045,9.044C488.978-343.213,493.027-339.164,498.022-339.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.807-339.164c4.994,0,9.044-4.05,9.044-9.045c0-4.995-4.05-9.044-9.044-9.044 c-4.996,0-9.046,4.049-9.046,9.044C534.761-343.213,538.811-339.164,543.807-339.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.589-339.164c4.996,0,9.045-4.05,9.045-9.045c0-4.995-4.049-9.044-9.045-9.044 c-4.995,0-9.044,4.049-9.044,9.044C580.545-343.213,584.594-339.164,589.589-339.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.373-339.164c4.995,0,9.044-4.05,9.044-9.045c0-4.995-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044C626.328-343.213,630.377-339.164,635.373-339.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M681.156-339.164c4.995,0,9.045-4.05,9.045-9.045c0-4.995-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044C672.112-343.213,676.161-339.164,681.156-339.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M269.105-292.805c4.995,0,9.045-4.05,9.045-9.045c0-4.995-4.05-9.044-9.045-9.044 c-4.995,0-9.045,4.049-9.045,9.044C260.06-296.855,264.11-292.805,269.105-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.888-292.805c4.995,0,9.046-4.05,9.046-9.045c0-4.995-4.051-9.044-9.046-9.044 c-4.994,0-9.044,4.049-9.044,9.044C305.844-296.855,309.894-292.805,314.888-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M360.672-292.805c4.995,0,9.044-4.05,9.044-9.045c0-4.995-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044C351.627-296.855,355.677-292.805,360.672-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M406.455-292.805c4.995,0,9.045-4.05,9.045-9.045c0-4.995-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044C397.411-296.855,401.46-292.805,406.455-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.239-292.805c4.995,0,9.044-4.05,9.044-9.045c0-4.995-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044C443.194-296.855,447.244-292.805,452.239-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M498.022-292.805c4.995,0,9.045-4.05,9.045-9.045c0-4.995-4.05-9.044-9.045-9.044 s-9.045,4.049-9.045,9.044C488.978-296.855,493.027-292.805,498.022-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.807-292.805c4.994,0,9.044-4.05,9.044-9.045c0-4.995-4.05-9.044-9.044-9.044 c-4.996,0-9.046,4.049-9.046,9.044C534.761-296.855,538.811-292.805,543.807-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.589-292.805c4.996,0,9.045-4.05,9.045-9.045c0-4.995-4.049-9.044-9.045-9.044 c-4.995,0-9.044,4.049-9.044,9.044C580.545-296.855,584.594-292.805,589.589-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.373-292.805c4.995,0,9.044-4.05,9.044-9.045c0-4.995-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044C626.328-296.855,630.377-292.805,635.373-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M681.156-292.805c4.995,0,9.045-4.05,9.045-9.045c0-4.995-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044C672.112-296.855,676.161-292.805,681.156-292.805z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M269.1-246.449c4.995,0,9.045-4.049,9.045-9.044c0-4.995-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045C260.056-250.499,264.105-246.449,269.1-246.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.888-246.447c4.995,0,9.046-4.049,9.046-9.045c0-4.995-4.051-9.044-9.046-9.044 c-4.994,0-9.044,4.049-9.044,9.044C305.844-250.497,309.894-246.447,314.888-246.447z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M269.1-200.091c4.995,0,9.045-4.049,9.045-9.044c0-4.995-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045C260.056-204.141,264.105-200.091,269.1-200.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.888-200.089c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.994,0-9.044,4.049-9.044,9.045C305.844-204.138,309.894-200.089,314.888-200.089z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M406.455-200.089c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C397.411-204.138,401.46-200.089,406.455-200.089z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M402.176-348.156H43.756c-1.759-0.002-3.447-0.702-4.691-1.947 c-1.244-1.244-1.944-2.931-1.946-4.691v-88.908c0.002-1.759,0.702-3.447,1.946-4.691s2.932-1.944,4.691-1.946h358.419 c1.761,0.002,3.447,0.702,4.691,1.946s1.944,2.932,1.946,4.691v88.908c-0.002,1.76-0.702,3.447-1.946,4.691 C405.623-348.858,403.937-348.158,402.176-348.156z M43.756-447.685c-1.056,0.001-2.068,0.421-2.814,1.168 s-1.167,1.759-1.168,2.814v88.908c0.001,1.056,0.421,2.069,1.168,2.815c0.747,0.747,1.759,1.167,2.814,1.168h358.419 c1.057-0.001,2.068-0.421,2.815-1.168c0.746-0.746,1.166-1.759,1.167-2.815v-88.908c-0.001-1.056-0.421-2.068-1.167-2.814 c-0.747-0.747-1.759-1.167-2.815-1.168H43.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M90.218-371.372c15.396,0,27.877-12.481,27.877-27.877s-12.481-27.877-27.877-27.877 s-27.877,12.481-27.877,27.877S74.822-371.372,90.218-371.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M154.601-417.833c-1.233,0-2.414,0.49-3.286,1.361 c-0.871,0.871-1.361,2.053-1.361,3.285s0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h128.765 c1.231,0,2.414-0.489,3.285-1.36c0.872-0.872,1.36-2.054,1.36-3.286s-0.488-2.414-1.36-3.285c-0.871-0.871-2.054-1.361-3.285-1.361 H154.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M154.601-389.957c-1.233,0-2.414,0.49-3.286,1.361 c-0.871,0.871-1.361,2.053-1.361,3.285c0,1.232,0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h219.033 c1.233,0,2.414-0.489,3.286-1.36c0.871-0.872,1.361-2.054,1.361-3.286c0-1.232-0.49-2.414-1.361-3.285 c-0.872-0.871-2.053-1.361-3.286-1.361H154.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBE",
    fillOpacity: 0.2,
    d: "M726.08-153.018H367.661c-1.76-0.002-3.447-0.702-4.691-1.946 c-1.244-1.245-1.944-2.932-1.946-4.691v-88.909c0.002-1.76,0.702-3.447,1.946-4.691s2.932-1.944,4.691-1.946H726.08 c1.76,0.002,3.447,0.702,4.691,1.946s1.943,2.931,1.946,4.691v88.909c-0.003,1.759-0.702,3.446-1.946,4.691 C729.527-153.719,727.84-153.02,726.08-153.018z M367.661-252.545c-1.056,0.001-2.068,0.421-2.815,1.167 c-0.746,0.747-1.167,1.759-1.168,2.815v88.909c0.001,1.056,0.422,2.068,1.168,2.814c0.747,0.747,1.76,1.167,2.815,1.168H726.08 c1.056-0.001,2.068-0.421,2.815-1.168c0.745-0.746,1.166-1.758,1.168-2.814v-88.909c-0.002-1.056-0.423-2.068-1.168-2.815 c-0.747-0.746-1.76-1.166-2.815-1.167H367.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M414.122-176.232c15.397,0,27.878-12.481,27.878-27.877s-12.48-27.877-27.878-27.877 c-15.396,0-27.877,12.481-27.877,27.877S398.727-176.232,414.122-176.232z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M478.505-222.694c-1.231,0-2.414,0.49-3.285,1.361c-0.87,0.871-1.36,2.053-1.36,3.285 c0,1.233,0.49,2.414,1.36,3.286c0.871,0.871,2.054,1.361,3.285,1.361h118.146c1.231,0,2.414-0.49,3.285-1.361 c0.872-0.872,1.36-2.053,1.36-3.286c0-1.232-0.488-2.414-1.36-3.285c-0.871-0.871-2.054-1.361-3.285-1.361H478.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M478.505-194.817c-1.231,0-2.414,0.49-3.285,1.361c-0.87,0.871-1.36,2.053-1.36,3.285 c0,1.233,0.49,2.414,1.36,3.286c0.871,0.871,2.054,1.361,3.285,1.361h219.034c1.232,0,2.414-0.49,3.286-1.361 c0.871-0.872,1.36-2.053,1.36-3.286c0-1.232-0.489-2.414-1.36-3.285c-0.872-0.871-2.054-1.361-3.286-1.361H478.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.105-101.313c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.049-9.045,9.045C230.06-105.361,234.11-101.313,239.105-101.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888-101.313c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.049-9.043,9.045C275.844-105.361,279.893-101.313,284.888-101.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.672-101.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C321.627-105.361,325.677-101.313,330.672-101.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.455-101.313c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C367.411-105.361,371.46-101.313,376.455-101.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239-101.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C413.194-105.361,417.244-101.313,422.239-101.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.105-54.954c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.049-9.045,9.045C230.06-59.003,234.11-54.954,239.105-54.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888-54.954c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.049-9.043,9.045C275.844-59.003,279.893-54.954,284.888-54.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.672-54.954c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C321.627-59.003,325.677-54.954,330.672-54.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M376.455-54.954c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C367.411-59.003,371.46-54.954,376.455-54.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239-54.954c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C413.194-59.003,417.244-54.954,422.239-54.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164-54.954c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C514.119-59.003,518.168-54.954,523.164-54.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.105-8.597c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.05-9.045,9.045S234.11-8.597,239.105-8.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888-8.597c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.05-9.043,9.045S279.893-8.597,284.888-8.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.672-8.597c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S325.677-8.597,330.672-8.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.455-8.597c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S371.46-8.597,376.455-8.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239-8.597c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S417.244-8.597,422.239-8.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.105,37.762c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.05-9.045,9.045S234.11,37.762,239.105,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888,37.762c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.05-9.043,9.045S279.893,37.762,284.888,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.672,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S325.677,37.762,330.672,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.455,37.762c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S371.46,37.762,376.455,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S417.244,37.762,422.239,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M477.164,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S472.168,37.762,477.164,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M477.164-10.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C468.119-14.361,472.168-10.313,477.164-10.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M477.164-100.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C468.119-104.361,472.168-100.313,477.164-100.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S518.168,37.762,523.164,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164-10.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C514.119-14.361,518.168-10.313,523.164-10.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.947-100.313c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C513.903-104.361,517.952-100.313,522.947-100.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S564.168,37.762,569.164,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164-10.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C560.119-14.361,564.168-10.313,569.164-10.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.731-100.313c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.045,4.049-9.045,9.045C559.687-104.361,563.736-100.313,568.731-100.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.373,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S609.377,37.762,614.373,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.373-10.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C605.328-14.361,609.377-10.313,614.373-10.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.514-100.313c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.994,0-9.044,4.049-9.044,9.045C605.47-104.361,609.52-100.313,614.514-100.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,37.762c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S657.168,37.762,662.164,37.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164-10.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C653.119-14.361,657.168-10.313,662.164-10.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164-100.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C653.119-104.361,657.168-100.313,662.164-100.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239,84.121c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 s-9.045,4.051-9.045,9.045C413.194,80.07,417.244,84.121,422.239,84.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M477.164,84.121c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C468.119,80.07,472.168,84.121,477.164,84.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M477.164-55.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C468.119-59.361,472.168-55.313,477.164-55.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164,84.121c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C514.119,80.07,518.168,84.121,523.164,84.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164,84.121c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C560.119,80.07,564.168,84.121,569.164,84.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164-54.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C560.119-58.361,564.168-54.313,569.164-54.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.373,84.121c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C605.328,80.07,609.377,84.121,614.373,84.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.947-54.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C605.902-58.361,609.952-54.313,614.947-54.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,84.121c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C653.119,80.07,657.168,84.121,662.164,84.121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164-54.313c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C653.119-58.361,657.168-54.313,662.164-54.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239,130.479c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S417.244,130.479,422.239,130.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M477.164,130.479c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S472.168,130.479,477.164,130.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164,130.479c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S518.168,130.479,523.164,130.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164,130.479c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S564.168,130.479,569.164,130.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M614.373,130.479c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S609.377,130.479,614.373,130.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,130.479c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S657.168,130.479,662.164,130.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239,176.837c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S417.244,176.837,422.239,176.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M477.164,176.837c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S472.168,176.837,477.164,176.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164,176.837c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S518.168,176.837,523.164,176.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164,176.837c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S564.168,176.837,569.164,176.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.164,176.837c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S609.168,176.837,614.164,176.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,176.837c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S657.168,176.837,662.164,176.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.105,223.194c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.044-9.045-9.044 c-4.995,0-9.045,4.049-9.045,9.044S234.11,223.194,239.105,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888,223.194c4.995,0,9.046-4.05,9.046-9.045s-4.051-9.044-9.046-9.044 c-4.995,0-9.043,4.049-9.043,9.044S279.893,223.194,284.888,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888,399.688c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.049-9.043,9.045C275.844,395.639,279.893,399.688,284.888,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.672,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S325.677,223.194,330.672,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.672,399.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C321.627,395.639,325.677,399.688,330.672,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.455,223.194c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044S371.46,223.194,376.455,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.455,399.688c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C367.411,395.639,371.46,399.688,376.455,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S417.244,223.194,422.239,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.239,399.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C413.194,395.639,417.244,399.688,422.239,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M477.164,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S472.168,223.194,477.164,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M468.022,399.688c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.045,4.049-9.045,9.045C458.978,395.639,463.027,399.688,468.022,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M523.164,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S518.168,223.194,523.164,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M513.807,399.688c4.994,0,9.044-4.049,9.044-9.044c0-4.996-4.05-9.045-9.044-9.045 c-4.996,0-9.046,4.049-9.046,9.045C504.761,395.639,508.811,399.688,513.807,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M569.164,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S564.168,223.194,569.164,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M559.589,399.688c4.996,0,9.045-4.049,9.045-9.044c0-4.996-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.049-9.044,9.045C550.545,395.639,554.594,399.688,559.589,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M559.589,434.688c4.996,0,9.045-4.049,9.045-9.044c0-4.996-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.049-9.044,9.045C550.545,430.639,554.594,434.688,559.589,434.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M559.589,471.688c4.996,0,9.045-4.049,9.045-9.044c0-4.996-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.049-9.044,9.045C550.545,467.639,554.594,471.688,559.589,471.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M559.589,501.688c4.996,0,9.045-4.05,9.045-9.05c0-4.99-4.049-9.04-9.045-9.04 c-4.995,0-9.044,4.05-9.044,9.04C550.545,497.639,554.594,501.688,559.589,501.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.164,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S609.168,223.194,614.164,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M611.164,399.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C602.119,395.639,606.168,399.688,611.164,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M611.164,434.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C602.119,430.639,606.168,434.688,611.164,434.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M611.164,471.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C602.119,467.639,606.168,471.688,611.164,471.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M611.164,501.688c4.995,0,9.044-4.05,9.044-9.05c0-4.99-4.049-9.04-9.044-9.04 c-4.996,0-9.045,4.05-9.045,9.04C602.119,497.639,606.168,501.688,611.164,501.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,223.194c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S657.168,223.194,662.164,223.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,399.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C653.119,395.639,657.168,399.688,662.164,399.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,434.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C653.119,430.639,657.168,434.688,662.164,434.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,471.688c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C653.119,467.639,657.168,471.688,662.164,471.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M662.164,501.688c4.995,0,9.044-4.05,9.044-9.05c0-4.99-4.049-9.04-9.044-9.04 c-4.996,0-9.045,4.05-9.045,9.04C653.119,497.639,657.168,501.688,662.164,501.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.1,269.551c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S234.105,269.551,239.1,269.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888,269.553c4.995,0,9.046-4.049,9.046-9.045c0-4.995-4.051-9.044-9.046-9.044 c-4.995,0-9.043,4.049-9.043,9.044C275.844,265.504,279.893,269.553,284.888,269.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M239.1,315.908c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S234.105,315.908,239.1,315.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.888,315.91c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.05-9.043,9.045S279.893,315.91,284.888,315.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.455,315.91c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S371.46,315.91,376.455,315.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M372.176,167.844H13.756c-1.759-0.002-3.447-0.702-4.691-1.947 c-1.244-1.244-1.944-2.931-1.946-4.69V72.298c0.002-1.76,0.702-3.447,1.946-4.691c1.244-1.245,2.932-1.943,4.691-1.947h358.419 c1.761,0.004,3.447,0.702,4.691,1.947c1.244,1.244,1.944,2.932,1.946,4.691v88.908c-0.002,1.76-0.702,3.446-1.946,4.69 C375.623,167.142,373.937,167.842,372.176,167.844z M13.756,68.314c-1.056,0.002-2.068,0.422-2.814,1.168 c-0.747,0.747-1.167,1.759-1.168,2.815v88.908c0.001,1.056,0.421,2.068,1.168,2.814c0.747,0.747,1.759,1.167,2.814,1.168h358.419 c1.057-0.001,2.068-0.421,2.815-1.168c0.746-0.746,1.166-1.759,1.167-2.814V72.298c-0.001-1.057-0.421-2.068-1.167-2.815 c-0.747-0.746-1.759-1.166-2.815-1.168H13.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M60.218,144.629c15.396,0,27.877-12.481,27.877-27.877 c0-15.396-12.481-27.877-27.877-27.877s-27.877,12.48-27.877,27.877C32.341,132.147,44.822,144.629,60.218,144.629z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M124.601,98.167c-1.233,0-2.414,0.489-3.286,1.36c-0.871,0.871-1.361,2.054-1.361,3.285 c0,1.232,0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h128.765c1.232,0,2.414-0.489,3.285-1.36 c0.872-0.872,1.361-2.054,1.361-3.286c0-1.231-0.489-2.414-1.361-3.285c-0.871-0.871-2.053-1.36-3.285-1.36H124.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M124.601,126.044c-1.233,0-2.414,0.489-3.286,1.36 c-0.871,0.871-1.361,2.054-1.361,3.285c0,1.232,0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h219.033 c1.233,0,2.414-0.489,3.286-1.36c0.871-0.872,1.361-2.054,1.361-3.286c0-1.231-0.49-2.414-1.361-3.285 c-0.872-0.871-2.053-1.36-3.286-1.36H124.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBE",
    fillOpacity: 0.2,
    d: "M696.08,362.982H337.661c-1.76-0.002-3.447-0.702-4.691-1.945 c-1.244-1.245-1.944-2.933-1.946-4.691v-88.909c0.002-1.76,0.702-3.447,1.946-4.69c1.244-1.244,2.932-1.944,4.691-1.946H696.08 c1.76,0.002,3.447,0.702,4.691,1.946c1.244,1.243,1.943,2.931,1.946,4.69v88.909c-0.003,1.759-0.702,3.446-1.946,4.691 C699.527,362.28,697.84,362.98,696.08,362.982z M337.661,263.455c-1.056,0.001-2.068,0.421-2.815,1.167 c-0.746,0.747-1.167,1.759-1.168,2.814v88.909c0.001,1.055,0.422,2.068,1.168,2.813c0.747,0.747,1.76,1.167,2.815,1.169H696.08 c1.056-0.002,2.068-0.422,2.815-1.169c0.745-0.745,1.166-1.759,1.168-2.813v-88.909c-0.002-1.056-0.423-2.067-1.168-2.814 c-0.747-0.746-1.76-1.166-2.815-1.167H337.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M384.122,339.768c15.397,0,27.878-12.48,27.878-27.877s-12.48-27.877-27.878-27.877 c-15.396,0-27.877,12.48-27.877,27.877S368.727,339.768,384.122,339.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M448.505,293.306c-1.231,0-2.414,0.49-3.285,1.361c-0.87,0.871-1.36,2.053-1.36,3.284 c0,1.233,0.49,2.414,1.36,3.286c0.871,0.871,2.054,1.361,3.285,1.361h118.146c1.231,0,2.414-0.49,3.285-1.361 c0.872-0.872,1.36-2.053,1.36-3.286c0-1.231-0.488-2.413-1.36-3.284c-0.871-0.871-2.054-1.361-3.285-1.361H448.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M448.505,321.183c-1.231,0-2.414,0.49-3.285,1.361c-0.87,0.871-1.36,2.053-1.36,3.284 c0,1.233,0.49,2.414,1.36,3.286c0.871,0.871,2.054,1.361,3.285,1.361h219.034c1.232,0,2.414-0.49,3.286-1.361 c0.871-0.872,1.36-2.053,1.36-3.286c0-1.231-0.489-2.413-1.36-3.284c-0.872-0.871-2.054-1.361-3.286-1.361H448.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M59.1,463.673c4.995,0,9.044,4.049,9.044,9.044s-4.049,9.045-9.044,9.045 s-9.044-4.05-9.044-9.045S54.105,463.673,59.1,463.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M104.888,463.671c4.995,0,9.045,4.049,9.045,9.045c0,4.995-4.05,9.044-9.045,9.044 s-9.044-4.049-9.044-9.044C95.844,467.72,99.893,463.671,104.888,463.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M196.455,463.671c4.995,0,9.045,4.049,9.045,9.045c0,4.995-4.05,9.044-9.045,9.044 s-9.044-4.049-9.044-9.044C187.411,467.72,191.46,463.671,196.455,463.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBE",
    fillOpacity: 0.2,
    d: "M516.08,416.599H157.661c-1.76,0.002-3.447,0.702-4.691,1.946 c-1.245,1.245-1.945,2.932-1.947,4.69v88.913c0.002,1.76,0.702,3.44,1.947,4.69c1.244,1.239,2.931,1.939,4.691,1.939H516.08 c1.76,0,3.447-0.7,4.691-1.939c1.244-1.25,1.943-2.931,1.946-4.69v-88.913c-0.003-1.759-0.702-3.445-1.946-4.69 C519.527,417.301,517.84,416.601,516.08,416.599z M157.661,516.129c-1.056,0-2.068-0.42-2.815-1.17s-1.167-1.761-1.168-2.811 v-88.913c0.001-1.055,0.421-2.067,1.168-2.813c0.747-0.747,1.759-1.167,2.815-1.168H516.08c1.056,0.001,2.068,0.421,2.815,1.168 c0.745,0.746,1.166,1.759,1.168,2.813v88.913c-0.002,1.05-0.423,2.061-1.168,2.811c-0.747,0.75-1.76,1.17-2.815,1.17H157.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M204.122,439.813c15.397,0,27.878,12.481,27.878,27.877 c0,15.398-12.481,27.878-27.878,27.878c-15.396,0-27.877-12.479-27.877-27.878C176.245,452.295,188.726,439.813,204.122,439.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M268.505,486.278c-1.232,0-2.414-0.489-3.285-1.359 c-0.871-0.88-1.361-2.061-1.361-3.289c0-1.233,0.49-2.414,1.361-3.286c0.871-0.871,2.053-1.361,3.285-1.361h118.146 c1.231,0,2.414,0.49,3.285,1.361c0.872,0.872,1.36,2.053,1.36,3.286c0,1.229-0.488,2.409-1.36,3.289 c-0.871,0.87-2.054,1.359-3.285,1.359H268.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M268.505,458.398c-1.232,0-2.414-0.49-3.285-1.36c-0.871-0.871-1.361-2.054-1.361-3.285 c0-1.233,0.49-2.414,1.361-3.286c0.871-0.871,2.053-1.361,3.285-1.361h219.034c1.232,0,2.414,0.49,3.286,1.361 c0.871,0.872,1.36,2.053,1.36,3.286c0,1.231-0.489,2.414-1.36,3.285c-0.872,0.87-2.054,1.36-3.286,1.36H268.505z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 6.916,
    y: 576.666,
    width: 725.599,
    height: 836.095
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 6.916,
    y: 576.666,
    width: 725.599,
    height: 836.095,
    id: "mask0_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16.084,
    y: 555.592,
    fill: "#C4C4C4",
    filter: "url(#Adobe_OpacityMaskFilter_1_)",
    width: 720,
    height: 1024
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M268.902,594.755c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.05-9.045,9.045S263.907,594.755,268.902,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.685,594.755c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.994,0-9.044,4.05-9.044,9.045S309.69,594.755,314.685,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M360.469,594.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S355.474,594.755,360.469,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M406.252,594.755c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S401.257,594.755,406.252,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.036,594.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S447.041,594.755,452.036,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M497.819,594.755c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.045,4.05-9.045,9.045S492.824,594.755,497.819,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.604,594.755c4.994,0,9.044-4.049,9.044-9.044s-4.05-9.045-9.044-9.045 c-4.996,0-9.046,4.05-9.046,9.045S538.607,594.755,543.604,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.386,594.755c4.996,0,9.045-4.049,9.045-9.044s-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.05-9.044,9.045S584.391,594.755,589.386,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.17,594.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S630.174,594.755,635.17,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M680.953,594.755c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S675.958,594.755,680.953,594.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.036,641.113c4.995,0,9.044-4.05,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C442.991,637.063,447.041,641.113,452.036,641.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M497.819,641.113c4.995,0,9.045-4.05,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.045,4.049-9.045,9.045C488.774,637.063,492.824,641.113,497.819,641.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.604,641.113c4.994,0,9.044-4.05,9.044-9.044c0-4.996-4.05-9.045-9.044-9.045 c-4.996,0-9.046,4.049-9.046,9.045C534.558,637.063,538.607,641.113,543.604,641.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.386,641.113c4.996,0,9.045-4.05,9.045-9.044c0-4.996-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.049-9.044,9.045C580.342,637.063,584.391,641.113,589.386,641.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.17,641.113c4.995,0,9.044-4.05,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C626.125,637.063,630.174,641.113,635.17,641.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M680.953,641.113c4.995,0,9.045-4.05,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C671.909,637.063,675.958,641.113,680.953,641.113z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.036,687.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S447.041,687.472,452.036,687.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M497.819,687.472c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.045-9.045-9.045 s-9.045,4.05-9.045,9.045S492.824,687.472,497.819,687.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.604,687.472c4.994,0,9.044-4.05,9.044-9.045s-4.05-9.045-9.044-9.045 c-4.996,0-9.046,4.05-9.046,9.045S538.607,687.472,543.604,687.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.386,687.472c4.996,0,9.045-4.05,9.045-9.045s-4.049-9.045-9.045-9.045 c-4.995,0-9.044,4.05-9.044,9.045S584.391,687.472,589.386,687.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M635.17,687.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S630.174,687.472,635.17,687.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M680.953,687.472c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S675.958,687.472,680.953,687.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.036,733.829c4.995,0,9.044-4.049,9.044-9.045c0-4.994-4.049-9.043-9.044-9.043 s-9.045,4.049-9.045,9.043C442.991,729.78,447.041,733.829,452.036,733.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M497.819,733.829c4.995,0,9.045-4.049,9.045-9.045c0-4.994-4.05-9.043-9.045-9.043 s-9.045,4.049-9.045,9.043C488.774,729.78,492.824,733.829,497.819,733.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.604,733.829c4.994,0,9.044-4.049,9.044-9.045c0-4.994-4.05-9.043-9.044-9.043 c-4.996,0-9.046,4.049-9.046,9.043C534.558,729.78,538.607,733.829,543.604,733.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.386,733.829c4.996,0,9.045-4.049,9.045-9.045c0-4.994-4.049-9.043-9.045-9.043 c-4.995,0-9.044,4.049-9.044,9.043C580.342,729.78,584.391,733.829,589.386,733.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.17,733.829c4.995,0,9.044-4.049,9.044-9.045c0-4.994-4.049-9.043-9.044-9.043 c-4.996,0-9.045,4.049-9.045,9.043C626.125,729.78,630.174,733.829,635.17,733.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M680.953,733.829c4.995,0,9.045-4.049,9.045-9.045c0-4.994-4.05-9.043-9.045-9.043 s-9.044,4.049-9.044,9.043C671.909,729.78,675.958,733.829,680.953,733.829z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M268.902,780.188c4.995,0,9.045-4.051,9.045-9.046s-4.05-9.044-9.045-9.044 c-4.995,0-9.045,4.049-9.045,9.044S263.907,780.188,268.902,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.685,780.188c4.995,0,9.046-4.051,9.046-9.046s-4.051-9.044-9.046-9.044 c-4.994,0-9.044,4.049-9.044,9.044S309.69,780.188,314.685,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M360.469,780.188c4.995,0,9.044-4.051,9.044-9.046s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S355.474,780.188,360.469,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M406.252,780.188c4.995,0,9.045-4.051,9.045-9.046s-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044S401.257,780.188,406.252,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M452.036,780.188c4.995,0,9.044-4.051,9.044-9.046s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S447.041,780.188,452.036,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M497.819,780.188c4.995,0,9.045-4.051,9.045-9.046s-4.05-9.044-9.045-9.044 s-9.045,4.049-9.045,9.044S492.824,780.188,497.819,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M543.604,780.188c4.994,0,9.044-4.051,9.044-9.046s-4.05-9.044-9.044-9.044 c-4.996,0-9.046,4.049-9.046,9.044S538.607,780.188,543.604,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M589.386,780.188c4.996,0,9.045-4.051,9.045-9.046s-4.049-9.044-9.045-9.044 c-4.995,0-9.044,4.049-9.044,9.044S584.391,780.188,589.386,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M635.17,780.188c4.995,0,9.044-4.051,9.044-9.046s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S630.174,780.188,635.17,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M680.953,780.188c4.995,0,9.045-4.051,9.045-9.046s-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044S675.958,780.188,680.953,780.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M268.897,826.544c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.046-9.045-9.046 s-9.044,4.051-9.044,9.046S263.902,826.544,268.897,826.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.685,826.546c4.995,0,9.046-4.049,9.046-9.045c0-4.995-4.051-9.044-9.046-9.044 c-4.994,0-9.044,4.049-9.044,9.044C305.641,822.497,309.69,826.546,314.685,826.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M268.897,872.901c4.995,0,9.045-4.049,9.045-9.043c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C259.853,868.853,263.902,872.901,268.897,872.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M314.685,872.903c4.995,0,9.046-4.049,9.046-9.043c0-4.996-4.051-9.045-9.046-9.045 c-4.994,0-9.044,4.049-9.044,9.045C305.641,868.854,309.69,872.903,314.685,872.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M406.252,872.903c4.995,0,9.045-4.049,9.045-9.043c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C397.208,868.854,401.257,872.903,406.252,872.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M401.973,724.837H43.553c-1.759-0.002-3.447-0.702-4.691-1.947 c-1.244-1.244-1.944-2.931-1.946-4.691V629.29c0.002-1.759,0.702-3.446,1.946-4.69s2.932-1.944,4.691-1.946h358.419 c1.761,0.002,3.447,0.702,4.691,1.946s1.944,2.932,1.946,4.69v88.908c-0.002,1.761-0.702,3.447-1.946,4.691 C405.42,724.135,403.733,724.835,401.973,724.837z M43.553,625.308c-1.056,0.002-2.068,0.422-2.814,1.168 c-0.747,0.747-1.167,1.76-1.168,2.814v88.908c0.001,1.057,0.421,2.069,1.168,2.815c0.747,0.747,1.759,1.167,2.814,1.168h358.419 c1.057-0.001,2.068-0.421,2.815-1.168c0.746-0.746,1.166-1.759,1.167-2.815V629.29c-0.001-1.055-0.421-2.067-1.167-2.814 c-0.747-0.746-1.759-1.166-2.815-1.168H43.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M90.015,701.622c15.396,0,27.877-12.481,27.877-27.877 c0-15.396-12.481-27.877-27.877-27.877s-27.877,12.48-27.877,27.877C62.138,689.141,74.619,701.622,90.015,701.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M154.398,655.16c-1.233,0-2.414,0.489-3.286,1.36c-0.871,0.871-1.361,2.053-1.361,3.285 s0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h128.765c1.231,0,2.414-0.489,3.285-1.36 c0.872-0.872,1.36-2.054,1.36-3.286s-0.488-2.414-1.36-3.285c-0.871-0.871-2.054-1.36-3.285-1.36H154.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M154.398,683.036c-1.233,0-2.414,0.49-3.286,1.361 c-0.871,0.871-1.361,2.053-1.361,3.285s0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h219.033 c1.233,0,2.414-0.489,3.286-1.36c0.871-0.872,1.361-2.054,1.361-3.286s-0.49-2.414-1.361-3.285 c-0.872-0.871-2.053-1.361-3.286-1.361H154.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBE",
    fillOpacity: 0.2,
    d: "M725.877,919.976H367.458c-1.76-0.002-3.447-0.701-4.691-1.945 c-1.244-1.246-1.944-2.933-1.946-4.691V824.43c0.002-1.76,0.702-3.446,1.946-4.69s2.932-1.944,4.691-1.946h358.419 c1.76,0.002,3.447,0.702,4.691,1.946s1.943,2.931,1.946,4.69v88.909c-0.003,1.759-0.702,3.445-1.946,4.691 C729.324,919.274,727.637,919.974,725.877,919.976z M367.458,820.448c-1.056,0-2.068,0.42-2.815,1.166 c-0.746,0.748-1.167,1.76-1.168,2.815v88.909c0.001,1.057,0.422,2.068,1.168,2.814c0.747,0.746,1.76,1.166,2.815,1.168h358.419 c1.056-0.002,2.068-0.422,2.815-1.168c0.745-0.746,1.166-1.758,1.168-2.814V824.43c-0.002-1.056-0.423-2.067-1.168-2.815 c-0.747-0.746-1.76-1.166-2.815-1.166H367.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M413.919,896.761c15.397,0,27.878-12.48,27.878-27.877s-12.48-27.877-27.878-27.877 c-15.396,0-27.877,12.48-27.877,27.877S398.523,896.761,413.919,896.761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M478.302,850.299c-1.231,0-2.414,0.489-3.285,1.36c-0.87,0.871-1.36,2.054-1.36,3.285 c0,1.233,0.49,2.414,1.36,3.287c0.871,0.87,2.054,1.36,3.285,1.36h118.146c1.231,0,2.414-0.49,3.285-1.36 c0.872-0.873,1.36-2.054,1.36-3.287c0-1.231-0.488-2.414-1.36-3.285c-0.871-0.871-2.054-1.36-3.285-1.36H478.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M478.302,878.176c-1.231,0-2.414,0.49-3.285,1.36c-0.87,0.871-1.36,2.054-1.36,3.285 c0,1.233,0.49,2.414,1.36,3.287c0.871,0.871,2.054,1.36,3.285,1.36h219.034c1.232,0,2.414-0.489,3.286-1.36 c0.871-0.873,1.36-2.054,1.36-3.287c0-1.231-0.489-2.414-1.36-3.285c-0.872-0.87-2.054-1.36-3.286-1.36H478.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.902,971.681c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.049-9.045,9.045C229.857,967.632,233.907,971.681,238.902,971.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,971.681c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.049-9.043,9.045C275.641,967.632,279.69,971.681,284.685,971.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.469,971.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C321.424,967.632,325.474,971.681,330.469,971.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.252,971.681c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C367.208,967.632,371.257,971.681,376.252,971.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,971.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C412.991,967.632,417.041,971.681,422.036,971.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.902,1018.039c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.049-9.045,9.045C229.857,1013.99,233.907,1018.039,238.902,1018.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,1018.039c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.049-9.043,9.045C275.641,1013.99,279.69,1018.039,284.685,1018.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.469,1018.039c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C321.424,1013.99,325.474,1018.039,330.469,1018.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M376.252,1018.039c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C367.208,1013.99,371.257,1018.039,376.252,1018.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1018.039c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C412.991,1013.99,417.041,1018.039,422.036,1018.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1018.039c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C513.916,1013.99,517.965,1018.039,522.961,1018.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.902,1064.396c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.05-9.045,9.045S233.907,1064.396,238.902,1064.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,1064.396c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.05-9.043,9.045S279.69,1064.396,284.685,1064.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.469,1064.396c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S325.474,1064.396,330.469,1064.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.252,1064.396c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S371.257,1064.396,376.252,1064.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1064.396c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S417.041,1064.396,422.036,1064.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.902,1110.755c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 c-4.995,0-9.045,4.05-9.045,9.045S233.907,1110.755,238.902,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,1110.755c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.05-9.043,9.045S279.69,1110.755,284.685,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.469,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S325.474,1110.755,330.469,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.252,1110.755c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S371.257,1110.755,376.252,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S417.041,1110.755,422.036,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M476.961,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S471.965,1110.755,476.961,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M476.961,1062.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C467.916,1058.632,471.965,1062.681,476.961,1062.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M476.961,972.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C467.916,968.632,471.965,972.681,476.961,972.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S517.965,1110.755,522.961,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1062.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C513.916,1058.632,517.965,1062.681,522.961,1062.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.744,972.681c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.044,4.049-9.044,9.045C513.7,968.632,517.749,972.681,522.744,972.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S563.965,1110.755,568.961,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1062.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C559.916,1058.632,563.965,1062.681,568.961,1062.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.528,972.681c4.995,0,9.045-4.049,9.045-9.044c0-4.996-4.05-9.045-9.045-9.045 s-9.045,4.049-9.045,9.045C559.483,968.632,563.533,972.681,568.528,972.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.17,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S609.174,1110.755,614.17,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.17,1062.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C605.125,1058.632,609.174,1062.681,614.17,1062.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.311,972.681c4.995,0,9.046-4.049,9.046-9.044c0-4.996-4.051-9.045-9.046-9.045 c-4.994,0-9.044,4.049-9.044,9.045C605.267,968.632,609.316,972.681,614.311,972.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1110.755c4.995,0,9.044-4.049,9.044-9.044s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S656.965,1110.755,661.961,1110.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1062.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C652.916,1058.632,656.965,1062.681,661.961,1062.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,972.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C652.916,968.632,656.965,972.681,661.961,972.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1157.114c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 s-9.045,4.051-9.045,9.045C412.991,1153.063,417.041,1157.114,422.036,1157.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M476.961,1157.114c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C467.916,1153.063,471.965,1157.114,476.961,1157.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M476.961,1017.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C467.916,1013.632,471.965,1017.681,476.961,1017.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1157.114c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C513.916,1153.063,517.965,1157.114,522.961,1157.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1157.114c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C559.916,1153.063,563.965,1157.114,568.961,1157.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1018.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C559.916,1014.632,563.965,1018.681,568.961,1018.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.17,1157.114c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C605.125,1153.063,609.174,1157.114,614.17,1157.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M614.744,1018.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 s-9.045,4.049-9.045,9.045C605.699,1014.632,609.749,1018.681,614.744,1018.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1157.114c4.995,0,9.044-4.051,9.044-9.046c0-4.994-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.051-9.045,9.045C652.916,1153.063,656.965,1157.114,661.961,1157.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1018.681c4.995,0,9.044-4.049,9.044-9.044c0-4.996-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.049-9.045,9.045C652.916,1014.632,656.965,1018.681,661.961,1018.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1203.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 s-9.045,4.05-9.045,9.045S417.041,1203.472,422.036,1203.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M476.961,1203.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S471.965,1203.472,476.961,1203.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1203.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S517.965,1203.472,522.961,1203.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1203.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S563.965,1203.472,568.961,1203.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M614.17,1203.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S609.174,1203.472,614.17,1203.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1203.472c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.045-9.044-9.045 c-4.996,0-9.045,4.05-9.045,9.045S656.965,1203.472,661.961,1203.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1249.83c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S417.041,1249.83,422.036,1249.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M476.961,1249.83c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S471.965,1249.83,476.961,1249.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1249.83c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S517.965,1249.83,522.961,1249.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1249.83c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S563.965,1249.83,568.961,1249.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M613.961,1249.83c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S608.965,1249.83,613.961,1249.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1249.83c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S656.965,1249.83,661.961,1249.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.902,1296.188c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.044-9.045-9.044 c-4.995,0-9.045,4.049-9.045,9.044S233.907,1296.188,238.902,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,1296.188c4.995,0,9.046-4.05,9.046-9.045s-4.051-9.044-9.046-9.044 c-4.995,0-9.043,4.049-9.043,9.044S279.69,1296.188,284.685,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M330.469,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S325.474,1296.188,330.469,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.252,1296.188c4.995,0,9.045-4.05,9.045-9.045s-4.05-9.044-9.045-9.044 s-9.044,4.049-9.044,9.044S371.257,1296.188,376.252,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M422.036,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 s-9.045,4.049-9.045,9.044S417.041,1296.188,422.036,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M476.961,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S471.965,1296.188,476.961,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M522.961,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S517.965,1296.188,522.961,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M568.961,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S563.965,1296.188,568.961,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M613.961,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S608.965,1296.188,613.961,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M661.961,1296.188c4.995,0,9.044-4.05,9.044-9.045s-4.049-9.044-9.044-9.044 c-4.996,0-9.045,4.049-9.045,9.044S656.965,1296.188,661.961,1296.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.897,1342.544c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S233.902,1342.544,238.897,1342.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,1342.546c4.995,0,9.046-4.049,9.046-9.045c0-4.995-4.051-9.044-9.046-9.044 c-4.995,0-9.043,4.049-9.043,9.044C275.641,1338.497,279.69,1342.546,284.685,1342.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M238.897,1388.901c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S233.902,1388.901,238.897,1388.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M284.685,1388.903c4.995,0,9.046-4.049,9.046-9.044s-4.051-9.045-9.046-9.045 c-4.995,0-9.043,4.05-9.043,9.045S279.69,1388.903,284.685,1388.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M376.252,1388.903c4.995,0,9.045-4.049,9.045-9.044s-4.05-9.045-9.045-9.045 s-9.044,4.05-9.044,9.045S371.257,1388.903,376.252,1388.903z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M371.973,1240.837H13.553c-1.759-0.002-3.447-0.702-4.691-1.947 c-1.244-1.244-1.944-2.931-1.946-4.69v-88.908c0.002-1.76,0.702-3.447,1.946-4.691c1.244-1.245,2.932-1.943,4.691-1.947h358.419 c1.761,0.004,3.447,0.702,4.691,1.947c1.244,1.244,1.944,2.932,1.946,4.691v88.908c-0.002,1.76-0.702,3.446-1.946,4.69 C375.42,1240.135,373.733,1240.835,371.973,1240.837z M13.553,1141.308c-1.056,0.002-2.068,0.422-2.814,1.168 c-0.747,0.747-1.167,1.759-1.168,2.815v88.908c0.001,1.056,0.421,2.068,1.168,2.814c0.747,0.747,1.759,1.167,2.814,1.168h358.419 c1.057-0.001,2.068-0.421,2.815-1.168c0.746-0.746,1.166-1.759,1.167-2.814v-88.908c-0.001-1.057-0.421-2.068-1.167-2.815 c-0.747-0.746-1.759-1.166-2.815-1.168H13.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M60.015,1217.622c15.396,0,27.877-12.481,27.877-27.877 c0-15.396-12.481-27.877-27.877-27.877s-27.877,12.48-27.877,27.877C32.138,1205.141,44.619,1217.622,60.015,1217.622z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M124.398,1171.16c-1.233,0-2.414,0.489-3.286,1.36 c-0.871,0.871-1.361,2.054-1.361,3.285c0,1.232,0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h128.765 c1.232,0,2.414-0.489,3.285-1.36c0.872-0.872,1.361-2.054,1.361-3.286c0-1.231-0.489-2.414-1.361-3.285 c-0.871-0.871-2.053-1.36-3.285-1.36H124.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M124.398,1199.037c-1.233,0-2.414,0.489-3.286,1.36 c-0.871,0.871-1.361,2.054-1.361,3.285c0,1.232,0.49,2.414,1.361,3.286c0.872,0.871,2.053,1.36,3.286,1.36h219.033 c1.233,0,2.414-0.489,3.286-1.36c0.871-0.872,1.361-2.054,1.361-3.286c0-1.231-0.49-2.414-1.361-3.285 c-0.872-0.871-2.053-1.36-3.286-1.36H124.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD1719",
    fillOpacity: 0.2,
    d: "M383.919,1412.761c15.397,0,27.878-12.48,27.878-27.877s-12.48-27.877-27.878-27.877 c-15.396,0-27.877,12.48-27.877,27.877S368.523,1412.761,383.919,1412.761z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M448.302,1366.299c-1.231,0-2.414,0.49-3.285,1.361c-0.87,0.871-1.36,2.053-1.36,3.284 c0,1.233,0.49,2.414,1.36,3.286c0.871,0.871,2.054,1.361,3.285,1.361h118.146c1.231,0,2.414-0.49,3.285-1.361 c0.872-0.872,1.36-2.053,1.36-3.286c0-1.231-0.488-2.413-1.36-3.284c-0.871-0.871-2.054-1.361-3.285-1.361H448.302z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.2,
    d: "M448.302,1394.176c-1.231,0-2.414,0.49-3.285,1.361c-0.87,0.871-1.36,2.053-1.36,3.284 c0,1.233,0.49,2.414,1.36,3.286c0.871,0.871,2.054,1.361,3.285,1.361h219.034c1.232,0,2.414-0.49,3.286-1.361 c0.871-0.872,1.36-2.053,1.36-3.286c0-1.231-0.489-2.413-1.36-3.284c-0.872-0.871-2.054-1.361-3.286-1.361H448.302z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRightMobile);
export default __webpack_public_path__ + "static/media/background_right_mobile.5f4b4f55abbdcee78e2ae7d5a4d11379.svg";
export { ForwardRef as ReactComponent };